import React from "react";
import { useLocation } from "react-router-dom";
import Maintenance from "./mantenimiento";

const ProtectedRoute = ({ component: Component, ...props }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const idAdministrador = params.get("idAdministrador");

   
  const adminUsers = [

  ];  

   
  const isAdmin = adminUsers.includes(idAdministrador);

   
   
  const ComponentToRender = isAdmin ? Maintenance : Component;
  return <ComponentToRender {...props} />;
};

export default ProtectedRoute;

